"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteCompanyDocument = void 0;
/**
 * Deletes a company document from the company's document store and removes the reference to it from the company's document list.

 */
var deleteCompanyDocument = function (instance) {
    return function (id, filename, config) {
        return instance.delete("/users/companies/".concat(id, "/documents/").concat(filename), config);
    };
};
exports.deleteCompanyDocument = deleteCompanyDocument;
